import {
  GENERAL_MY_ORDERS,
  WISHLIST_TITLE,
  GENERAL_MY_DETAILS
} from '@components/utils/textVariables'
import { EmptyGuid } from './constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'

const myAddressMegaMenu = (user: any) => {
  recordGA4Event(window, GA_EVENT.MY_SAVED_ADDRESS_MEGA_MENU, {
    current_page: 'My Account',
    loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
  })
}

const myAddressSidepanel = (user: any) => {
  recordGA4Event(window, GA_EVENT.MYADDRESS_SIDEPANEL, {
    current_page: '/profile',
    loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
  })
}

const myProfileSidepanel = (user: any) => {
  if (typeof window !== "undefined") {
    recordGA4Event(window, 'my_profile', {
      current_page: "/profile",
    });
  }
}

const noCall = (user: any) => {
  //
}

const viewWishlist = (user: any) => {
  recordGA4Event(window, GA_EVENT.WISHLIST, {
    ecommerce: {
      header: 'Menu Bar',
      current_page: 'My Account',
      loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
    },
  })
}

const viewReferAndEarn = (user: any) => {
  recordGA4Event(window, GA_EVENT.REFER_EARN, {
    ecommerce: {
      current_page: 'My Account',
      loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
    },
  })
}

export const config: any = [
  {
    type: 'tab',
    text: GENERAL_MY_DETAILS,
    mtext: GENERAL_MY_DETAILS,
    props: 'details',
    href: "/my-account",
    onClick: (user: any) => myProfileSidepanel(user),
  },
  {
    type: 'tab',
    text: GENERAL_MY_ORDERS,
    mtext: GENERAL_MY_ORDERS,
    props: 'orders',
    href: '/my-account/orders',
    onClick: (user: any) => noCall(user),
  },
  // {
  //   type: 'tab',
  //   text: GENERAL_MY_RETURNS,
  //   props: 'returns',
  // },
  {
    type: 'tab',
    text: 'My Saved Payment',
    mtext: 'My Saved Payment',
    props: 'saved-payment',
    href: '/my-account/saved-payments',
    onClick: (user: any) => noCall(user),
  },
  {
    type: 'tab',
    text: 'My Saved Address',
    mtext: 'My Saved Address',
    props: 'address-book',
    href: '/my-account/address-book',
    onClick: (user: any) => myAddressMegaMenu(user),
  },
  {
    type: 'tab',
    text: WISHLIST_TITLE,
    mtext: WISHLIST_TITLE,
    props: 'wishlist',
    href: '/my-account/wishlist',
    onClick: (user: any) => viewWishlist(user),
  },
  {
    type: 'tab',
    text: 'Share Your Bro Code & Earn',
    mtext: 'Share Your Bro Code & Earn',
    props: 'refer-earn',
    href: '/my-account/referral',
    onClick: (user: any) => viewReferAndEarn(user),
  },
  // {
  //   type: 'tab',
  //   text: GENERAL_CONTACT_PREFERENCES,
  //   props: 'contact',
  // },
]
